function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "icon/outlined/suggested/plus",
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "h3x3jq0mra"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "icon/outlined/suggested/plus (clip mask)",
    transform: "translate(2 2)",
    style: {
      fill: "#current"
    },
    d: "M0 0h12v12H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "icon/outlined/suggested/plus",
    transform: "translate(-2 -2)",
    style: {
      clipPath: "url(#h3x3jq0mra)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "icon/outlined/suggested/plus (clip group)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "icon/outlined/suggested/plus (style)",
    transform: "translate(1 1)",
    style: {
      fill: "none"
    },
    d: "M0 0h14v14H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.125 0h.938a.11.11 0 0 1 .125.125v11a.11.11 0 0 1-.125.125H.125A.11.11 0 0 1 0 11.125v-11A.11.11 0 0 1 .125 0z",
    transform: "translate(7.406 2.375)",
    style: {
      fill: "#current"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Vector",
    d: "M.125 0h10.5a.11.11 0 0 1 .125.125v.938a.11.11 0 0 1-.125.125H.125A.11.11 0 0 1 0 1.063V.125A.11.11 0 0 1 .125 0z",
    transform: "translate(2.625 7.406)",
    style: {
      fill: "#current"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.4e38aca1f7b498260cebb441fd98bd8e.svg";
export { ForwardRef as ReactComponent };